import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  StreamControl,
  StreamControlResponse,
  StreamID,
} from '../common/stream_pb';
import {
  Banner,
  BannerLibraryAdd,
  BannerLibraryDelete,
  BannerLibraryGet,
  BannerLibraryGetAllByType,
  BannerLibraryGetStatsRequest,
  BannerLibraryGetStatsResponse,
  BannerLibrarySearchResponse,
  BannerLibrarySetArchived,
  BannerLibraryUpdate,
  Banners,
} from '../gateway/banner_pb';

import {
  BannerLibrary as __BannerLibrary,
} from '../gateway/banner_pb_service';

@Injectable({providedIn: 'root'})
export class BannerLibrary {

  constructor(private _ngZone: NgZone) {
  }

  /**
    Get banner library related stats.
  */
  getStats(request: BannerLibraryGetStatsRequest): Promise<BannerLibraryGetStatsResponse>;
  /**
    Get banner library related stats.
  */
  getStats(request: BannerLibraryGetStatsRequest, metadata: grpc.Metadata): Promise<BannerLibraryGetStatsResponse>;
  /**
    Get banner library related stats.
  */
  getStats(request: BannerLibraryGetStatsRequest, callback: (err: any|null, response: BannerLibraryGetStatsResponse, metadata: grpc.Metadata) => void): void;
  /**
    Get banner library related stats.
  */
  getStats(request: BannerLibraryGetStatsRequest, metadata: grpc.Metadata, callback: (err: any|null, response: BannerLibraryGetStatsResponse, metadata: grpc.Metadata) => void): void;

  getStats(request: BannerLibraryGetStatsRequest, arg1?: grpc.Metadata|((err: any|null, response: BannerLibraryGetStatsResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: BannerLibraryGetStatsResponse, metadata: grpc.Metadata) => void): Promise<BannerLibraryGetStatsResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<BannerLibraryGetStatsResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.GetStats, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  get(request: BannerLibraryGet): Promise<Banner>;
  get(request: BannerLibraryGet, metadata: grpc.Metadata): Promise<Banner>;
  get(request: BannerLibraryGet, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;
  get(request: BannerLibraryGet, metadata: grpc.Metadata, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;

  get(request: BannerLibraryGet, arg1?: grpc.Metadata|((err: any|null, response: Banner, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): Promise<Banner>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<Banner>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.Get, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getAllByType(request: BannerLibraryGetAllByType): Promise<Banners>;
  getAllByType(request: BannerLibraryGetAllByType, metadata: grpc.Metadata): Promise<Banners>;
  getAllByType(request: BannerLibraryGetAllByType, callback: (err: any|null, response: Banners, metadata: grpc.Metadata) => void): void;
  getAllByType(request: BannerLibraryGetAllByType, metadata: grpc.Metadata, callback: (err: any|null, response: Banners, metadata: grpc.Metadata) => void): void;

  getAllByType(request: BannerLibraryGetAllByType, arg1?: grpc.Metadata|((err: any|null, response: Banners, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: Banners, metadata: grpc.Metadata) => void): Promise<Banners>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<Banners>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.GetAllByType, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  /**
    Add new banner to the banner library.
  */
  add(request: BannerLibraryAdd): Promise<Banner>;
  /**
    Add new banner to the banner library.
  */
  add(request: BannerLibraryAdd, metadata: grpc.Metadata): Promise<Banner>;
  /**
    Add new banner to the banner library.
  */
  add(request: BannerLibraryAdd, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;
  /**
    Add new banner to the banner library.
  */
  add(request: BannerLibraryAdd, metadata: grpc.Metadata, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;

  add(request: BannerLibraryAdd, arg1?: grpc.Metadata|((err: any|null, response: Banner, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): Promise<Banner>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<Banner>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.Add, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  /**
    Edit existing banner. Attempts to only update whats different.
  */
  update(request: BannerLibraryUpdate): Promise<Banner>;
  /**
    Edit existing banner. Attempts to only update whats different.
  */
  update(request: BannerLibraryUpdate, metadata: grpc.Metadata): Promise<Banner>;
  /**
    Edit existing banner. Attempts to only update whats different.
  */
  update(request: BannerLibraryUpdate, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;
  /**
    Edit existing banner. Attempts to only update whats different.
  */
  update(request: BannerLibraryUpdate, metadata: grpc.Metadata, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;

  update(request: BannerLibraryUpdate, arg1?: grpc.Metadata|((err: any|null, response: Banner, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): Promise<Banner>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<Banner>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.Update, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  /**
    Delete existing banner. Optionally supply undo to true to undo a delete
 that occured within the last few minutes. Otherwise it is a no-op.
  */
  delete(request: BannerLibraryDelete): Promise<Banner>;
  /**
    Delete existing banner. Optionally supply undo to true to undo a delete
 that occured within the last few minutes. Otherwise it is a no-op.
  */
  delete(request: BannerLibraryDelete, metadata: grpc.Metadata): Promise<Banner>;
  /**
    Delete existing banner. Optionally supply undo to true to undo a delete
 that occured within the last few minutes. Otherwise it is a no-op.
  */
  delete(request: BannerLibraryDelete, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;
  /**
    Delete existing banner. Optionally supply undo to true to undo a delete
 that occured within the last few minutes. Otherwise it is a no-op.
  */
  delete(request: BannerLibraryDelete, metadata: grpc.Metadata, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;

  delete(request: BannerLibraryDelete, arg1?: grpc.Metadata|((err: any|null, response: Banner, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): Promise<Banner>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<Banner>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.Delete, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  /**
    Set the archived status of a banner
  */
  setArchived(request: BannerLibrarySetArchived): Promise<Banner>;
  /**
    Set the archived status of a banner
  */
  setArchived(request: BannerLibrarySetArchived, metadata: grpc.Metadata): Promise<Banner>;
  /**
    Set the archived status of a banner
  */
  setArchived(request: BannerLibrarySetArchived, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;
  /**
    Set the archived status of a banner
  */
  setArchived(request: BannerLibrarySetArchived, metadata: grpc.Metadata, callback: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): void;

  setArchived(request: BannerLibrarySetArchived, arg1?: grpc.Metadata|((err: any|null, response: Banner, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: Banner, metadata: grpc.Metadata) => void): Promise<Banner>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<Banner>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.SetArchived, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  search(request: StreamID): {cancel():void;close():void}&Observable<BannerLibrarySearchResponse>;
  search(request: StreamID, metadata: grpc.Metadata): {cancel():void;close():void}&Observable<BannerLibrarySearchResponse>;
  search(request: StreamID, onMessage: (message?: BannerLibrarySearchResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;
  search(request: StreamID, metadata: grpc.Metadata, onMessage: (message?: BannerLibrarySearchResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;

  search(request: StreamID, arg1?: grpc.Metadata|((message?: BannerLibrarySearchResponse) => void), arg2?: ((message?: BannerLibrarySearchResponse) => void)|((err: any) => void), arg3?: ((err: any) => void)|((code: number, msg: string|undefined, metadata: grpc.Metadata) => void), arg4?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): {cancel():void;close():void}&Observable<BannerLibrarySearchResponse>|void {
    let ret: any;
    let metadata: any;

    let onMessage: any;
    let onError: any;
    let onEnd: any;
    if(typeof arg1 === 'function') {
      onMessage = arg1;
      onError = arg2;
      onEnd = arg3;
    } else if(typeof arg2 === 'function') {
      metadata = arg1;
      onMessage = arg2;
      onError = arg3;
      onEnd = arg4;
    } else {
      metadata = arg1;
    }

    if(!onMessage) {
      let subject = new Subject<BannerLibrarySearchResponse>();
      ret = subject.asObservable();

      onMessage = (response: any) => {
        subject.next(response);
      };

      onError = (err: any) => {
        subject.error(err);
      };

      onEnd = (code: any, msg: any, metadata: any) => {
        subject.complete();
      };

    } else {
      if(!onError) {
        onError = (err: any) => console.error(err);
      }

      if(!onEnd) {
        onEnd = (code: any, msg: any, metadata: any) => {};
      }
    }

    let req = grpc.invoke(__BannerLibrary.Search, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onMessage: response => this._ngZone.run(() => {
        onMessage(response);
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code == grpc.Code.OK) {
          onEnd(code, msg, metadata);
        } else {
          let err = new Error(code + ' ' + (msg||''));
          (<any>err).code = code;
          onError(err);
        }
      })
    });

    (<any>ret).close = () => {
      console.warn('[Angular Grpc] .close() is deprecated use .cancel() instead');
      return req.close();
    };
    (<any>ret).cancel = () => req.close();
    return ret;
  }

  searchControl(request: StreamControl): Promise<StreamControlResponse>;
  searchControl(request: StreamControl, metadata: grpc.Metadata): Promise<StreamControlResponse>;
  searchControl(request: StreamControl, callback: (err: any|null, response: StreamControlResponse, metadata: grpc.Metadata) => void): void;
  searchControl(request: StreamControl, metadata: grpc.Metadata, callback: (err: any|null, response: StreamControlResponse, metadata: grpc.Metadata) => void): void;

  searchControl(request: StreamControl, arg1?: grpc.Metadata|((err: any|null, response: StreamControlResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: StreamControlResponse, metadata: grpc.Metadata) => void): Promise<StreamControlResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<StreamControlResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BannerLibrary.SearchControl, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

